import { useEffect, useState } from "react";
import { api, ROLE_LABELS, ALL_ROLES } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Users() {
  const { user } = useAuth();
  const [users, setUsers] = useState([]);
  const load = async () => { const { data } = await api.get("/users"); setUsers(data); };
  useEffect(() => { load(); }, []);

  const changeRole = async (id, role) => {
    await api.patch(`/users/${id}`, { role }); load();
  };
  const toggleActive = async (id, active) => {
    await api.patch(`/users/${id}`, { active: !active }); load();
  };

  const canEdit = user?.role === "admin";

  return (
    <div className="p-8 md:p-10 max-w-[1600px] mx-auto">
      <div className="overline">Directory</div>
      <h1 className="font-heading font-extrabold text-4xl sm:text-5xl tracking-tight mt-2 mb-8">Users & Roles</h1>

      <div className="border border-slate-200">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-slate-200 bg-slate-50">
              <th className="p-4 text-left overline">Name</th>
              <th className="p-4 text-left overline">Email</th>
              <th className="p-4 text-left overline">Organization</th>
              <th className="p-4 text-left overline">Role</th>
              <th className="p-4 text-left overline">Status</th>
              <th className="p-4 text-left overline">Created</th>
            </tr>
          </thead>
          <tbody>
            {users.map(u => (
              <tr key={u.id} className="border-b border-slate-100 hover:bg-slate-50">
                <td className="p-4 font-semibold">{u.name}</td>
                <td className="p-4 font-mono text-xs">{u.email}</td>
                <td className="p-4">{u.organization || "—"}</td>
                <td className="p-4">
                  {canEdit ? (
                    <select data-testid={`role-select-${u.id}`} value={u.role} onChange={e => changeRole(u.id, e.target.value)}
                      className="border border-slate-300 p-2 text-xs">
                      {ALL_ROLES.map(r => <option key={r} value={r}>{ROLE_LABELS[r]}</option>)}
                    </select>
                  ) : <span>{ROLE_LABELS[u.role]}</span>}
                </td>
                <td className="p-4">
                  {canEdit ? (
                    <button onClick={() => toggleActive(u.id, u.active)}
                      className={`px-2 py-1 text-[10px] font-bold uppercase tracking-wider ${u.active ? "bg-[#16A34A] text-white" : "bg-slate-400 text-white"}`}>
                      {u.active ? "Active" : "Inactive"}
                    </button>
                  ) : (
                    <span className={`px-2 py-1 text-[10px] font-bold uppercase tracking-wider ${u.active ? "bg-[#16A34A] text-white" : "bg-slate-400 text-white"}`}>
                      {u.active ? "Active" : "Inactive"}
                    </span>
                  )}
                </td>
                <td className="p-4 font-mono text-xs text-slate-500">{u.created_at?.slice(0,10)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
